import { Link } from "react-router-dom";

export default function Logo({ size = "md", className = "", monoColor }) {
  const sizes = {
    sm: "text-base",
    md: "text-lg md:text-xl",
    lg: "text-2xl md:text-3xl",
    xl: "text-4xl md:text-5xl",
  };
  return (
    <Link to="/" className={`ie-wordmark inline-block ${sizes[size]} ${className}`} data-testid="brand-logo" style={monoColor ? { color: monoColor } : undefined}>
      <span>INDUS</span>
      <span className="mx-1 opacity-40">·</span>
      <span>EIRENE</span>
    </Link>
  );
}
